import { BrowserRouter, Route, Routes } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Sidebar from "./components/Sidebar";
import RequireAuth from "./components/RequiredAuth";
import { AuthProvider } from "./context/AuthProvider";
import HR from "./pages/Hr.js";
import Candidate from "./pages/Candidate";
import Home from "./pages/Home.js";
import Registration from "./components/Registration";
import PsychometricTest from "./components/assessment/PsychometricTest.js";
import QuantitativeTest from "./components/assessment/QuantitativeTest";
import VocabularyTest from "./components/assessment/VocabularyTest.js";
import JavaTest from "./components/assessment/JavaTest.js";
import Accounts from "./components/assessment/AccountsTest.js";
import Excel from "./components/assessment/ExcelTest.js";
import AepCjaConsultantTest from "./components/assessment/AepCjaConsultantTest.js";
import DataEngineerTest from "./components/assessment/DataEngineerTest.js";
import BigQueryTest from "./components/assessment/BigQueryTest.js";
import DataScienceTest from "./components/assessment/PowerBiAndDataScienceTest.js";
import AepCdpArchitectTest from "./components/assessment/AepCdpArchitectTest.js";
import AdobeAnalyticsTest from "./components/assessment/AdobeAnalyticsTest.js";
import SqlTest from "./components/assessment/SqlTest.js";
import Reports from "./pages/Reports.js";
import "./App.css";
import Thankyou from "./pages/Thankyou";
import LinkExpired from "./pages/LinkExpired.js";
import { FadeLoader } from "react-spinners";
import Statistics from "./pages/Statistics.js";
import Admin from "./pages/Admin.js";
import Postjob from "./components/Postjob.js";
import Createhr from "./components/Createhr.js";
import Feedback from "./pages/Feedbacks.js";
import ProfilePage from "./components/ProfilePage.js";
import Panelist from "./components/Panelist.js";
import Dashboard from "./pages/Dashboard.js";
import Applicant from "./pages/Applicant.js";
import ApproveJobDetails from "./pages/Approve.js";
import Explore from "./pages/Explore.js";
import Schedule from "./pages/Schedule.js";
import Availability from "./pages/Availability.js";
import ImageCarousel from "./components/ImageCarousel.js";
import JobRegistration from "./pages/JobRegistration.js";
import BulkUpload from "./components/BulkUpload.js";
import EditCandidate from "./components/EditCandidate.js";
import Test from './components/campus/Test';
import GenAITest from "./components/assessment/GenAITest.js";
import AniTest from "./pages/AniTest.js";
import GenAITheoryTest from "./components/assessment/GenAITheoryTest.js";
import ManagersReport from "./pages/ManagersReport.js";
const App = () => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
  }, []);

  if (!isLoading) {
    return (
      <div style={{ textAlign: "center", margin: "200px auto" }}>
        <center>
          <FadeLoader color={"#00B4D2"} size={20} />
        </center>
        <div>Please wait a moment</div>
      </div>
    );
  }
  return (
    <BrowserRouter>
      <AuthProvider>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/login" element={<Home />} />
          <Route path="/register-job/:positionId" element={<JobRegistration />} />
          <Route path="/assessment/Data Engineer" element={<DataEngineerTest />} />
          <Route path="/assessment/sql" element={<SqlTest />} />
          <Route path="/job/:id" element={<ApproveJobDetails />} />
          {/* <Route path="/bulkupload" element={<BulkUpload />}/> */}


          <Route element={<RequireAuth />}>
            <Route path="/editCandidate" element={<Sidebar><EditCandidate /></Sidebar>} />
            <Route path="/help" element={<ImageCarousel />} />
            <Route path="/admins" element={<Sidebar><Admin /></Sidebar>} />
            <Route path="/registration" element={<Sidebar><Registration /></Sidebar>} />
            <Route path="/reports" element={<Sidebar><Reports /></Sidebar>} />
            <Route path="/candidate/candidate" element={<Candidate />} />
            <Route path="/assessment/psychometric" element={<PsychometricTest />} />
            <Route path="/assessment/quantitative" element={<QuantitativeTest />} />
            <Route path="/assessment/vocabulary" element={<VocabularyTest />} />
            <Route path="/assessment/java" element={<JavaTest />} />
            <Route path="/assessment/accounts" element={<Accounts />} />
            <Route path="/assessment/excel" element={<Excel />} />
            <Route path="/assessment/Aep Cja" element={<AepCjaConsultantTest />} />
            <Route path="/assessment/Power Bi And Data Science" element={<DataScienceTest />} />
            <Route path="/assessment/Aep Cdp Architect" element={<AepCdpArchitectTest />} />
            <Route path="/assessment/Adobe Analytics Implementation" element={<AdobeAnalyticsTest />} />
            <Route path="/assessment/Big Query" element={<BigQueryTest />} />
            <Route path="/assessment/Gen AI" element={<GenAITest />} />
            <Route path="/assessment/Gen AI Theory" element={<GenAITheoryTest />} />
            <Route path="/hr" element={<Sidebar><HR /></Sidebar>} />
            <Route path="/thankyou" element={<Thankyou />} />
            <Route path="/link-expired" element={<LinkExpired />} />
            <Route path="/statistics" element={<Statistics />} />
            <Route path="/dashboard" element={<Sidebar><Dashboard /></Sidebar>} />
            <Route path="/schedule" element={<Sidebar><Schedule /></Sidebar>} />
            <Route path="/postjob" element={<Sidebar><Postjob /></Sidebar>} />
            <Route path="/create-hr" element={<Sidebar><Createhr /></Sidebar>} />
            <Route path="/feedbacks" element={<Sidebar><Feedback /></Sidebar>} />
            <Route path="/slots" element={<Sidebar><Availability /></Sidebar>} />
            <Route path="/editProfile" element={<Sidebar><ProfilePage /></Sidebar>} />
            <Route path="/panelist/:id" element={<Sidebar><Panelist /></Sidebar>} />
            <Route path="/applicants" element={<Sidebar><Applicant /></Sidebar>} />
            <Route path='/provideFeedback/:id' element={<Sidebar><Panelist /></Sidebar>} />
            <Route path="/bulkupload" element={<Sidebar><BulkUpload /></Sidebar>} />
            <Route path="/managers-report" element={<Sidebar><ManagersReport /></Sidebar>} />
            {/* <Route path="/ani-tests" element={<Sidebar><AniTest /></Sidebar>} /> */}
            <Route path="/editCandidate" element={<Sidebar><EditCandidate /></Sidebar>} />
            {/* <Route path='/questionaire' element={<Sidebar><Questionaire /></Sidebar>} />
            <Route path='/questions/all' element={<Sidebar><QuestionList /></Sidebar>} /> */}
            {/* <Route path='/topic/edit/:id' element={<EditTopic />} /> */}
            {/* <Route path='/question/edit/:id' element={<Sidebar><QuestionForm /></Sidebar>} /> */}
            <Route path="/campus/Quantitative" element={<Test testType="Quantitative" />} />
            <Route path="/campus/Vocabulary" element={<Test testType="Vocabulary" />} />
            <Route path="/campus/Psychometric" element={<Test testType="Psychometric" />} />
          </Route>
          {/* <Route path="/editCandidate" element={<EditCandidate />}/> */}
        </Routes>

      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
